import Interface from "../../../views/administrador/Logistica/Interface";
import AutorizarOTs from "../../../views/administrador/Logistica/AutorizarOTs";
import EntregaCombustible from "../../../views/administrador/Logistica/EntregaCombustible";
import CtrlCombustibleExtCartelera from "../../../views/administrador/Logistica/CtrlCombustibleExtCartelera";
import CtrlCombustibleExtFacturacion from "../../../views/administrador/Logistica/CtrlCombustibleExtFacturacion";
import FfactSAP from "../../../views/administrador/Logistica/FfactSAP";




const routes_logistica = [
  {
    path: "/Interface",
    name: "Interface",
    icon: "",
    component: Interface,
    doNotShow: true,
  },
  {
    path: "/AutorizarOTs",
    name: "Autorizar OTs",
    icon: "",
    component: AutorizarOTs,
    doNotShow: true,
  },
  {
    path: "/EntregaCombustible",
    name: "Despacho Combustible",
    icon: "",
    component: EntregaCombustible,
    doNotShow: true,
  },
  {
    path: "/CtrlCombustibleExtCartelera",
    name: "Control Combustible Externo Cartelera",
    icon: "",
    component: CtrlCombustibleExtCartelera,
    doNotShow: true,
  },
  {
    path: "/CtrlCombustibleExtFacturacion",
    name: "Control Combustible Externo Facturacion",
    icon: "",
    component: CtrlCombustibleExtFacturacion,
    doNotShow: true,
  },
  {
    path: "/FfactSAP",
    name: "Ingresar Factura FFACSA",
    icon: "",
    component: FfactSAP,
    doNotShow: true,
  },
 
];

export default routes_logistica;
